import React from "react";

/**
 * GuidedRibbon — slim brass-outlined pill that announces the state of a
 * Guided Reflection walkthrough at the top of ProgressivePromptsStrip.
 *
 * Extracted from ReflectionCanvasArticle during the post-Phase-B refactor.
 * The rendered markup is a pure port of the inline version so no existing
 * data-testid or copy needs to change.
 *
 * Props:
 *   step        — zero-based current step index (0 → total-1)
 *   total       — total number of guided steps (typically 4)
 *   dataTestId  — required for QA selectors
 */
export default function GuidedRibbon({ step, total, dataTestId }) {
  return (
    <div
      className="text-[0.625rem] font-mono uppercase tracking-widest text-brass border border-brass/50 px-2 py-1"
      data-testid={dataTestId}
    >
      Guided · Step {step + 1} of {total} · saves to Working Journal
    </div>
  );
}
